export default __webpack_public_path__ + "static/media/baseline-signal_wifi_2_bar-24px.bfe46dac.svg";